import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import { IUser } from "@common/interfaces/user";

@Component({
    selector: 'users-selection',
    templateUrl: './users-selection.component.html',
    styleUrls: ['./users-selection.component.scss'],
    encapsulation: ViewEncapsulation.None
  })

  export class UsersSelectionComponent implements OnInit {
    @Input() control: FormControl;
    @Input() users: IUser[];
    @Input() disabled:boolean = false;

    userChange(user: IUser[]) {
        this.control.patchValue(user.map(u => u.id));
        this.control.markAsDirty();
    }

    ngOnInit(): void {
    }
  }
